import React from "react";

import CustomTooltip from "./CustomTooltip/CustomTooltip";

const ConfirmationScreen = ({ isOpen, onClose, children }) => {
  if (!isOpen) return null;
  return (
    <div className="confirmation-popup-overlay">
      <div className="confirmation-popup-content">
        <div className="confirmation-popup-header">
          <div className="confirmation-popup-btns">
            <CustomTooltip text="Close" placement="top">
              <button
                style={{ margin: "10px" }}
                className="btn-close"
                onClick={onClose}
              ></button>
            </CustomTooltip>
          </div>
        </div>
        <div className="confirmation-popup-body">{children}</div>
      </div>
    </div>
  );
};

export default ConfirmationScreen;
